import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TaskList } from '../../components/tasks/TaskList'
import VendorStaffScreen from '../../components/UserDashboard/VendorStaffScreen'

export const VendorStaffDashboard = () => {
	const dispatch = useDispatch()

	// const tasks = useSelector((state) => state.task.tasks)
	// useEffect(() => {
	// 	dispatch(ByAssignee())
	// }, [dispatch])

	return (
		<div>
			{/* <h1>Vendor staff dashboard</h1> */}
			{/* <h3>Tasks by</h3> */}
			{/* <TaskList tasks={tasks} staff={true} /> */}
			<VendorStaffScreen />
		</div>
	)
}